var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "recipient-container py-2" },
    [
      _c("v-server-table", {
        ref: "table",
        staticClass: "vue-custom-table no-pagination vue-custom-table-infinite",
        attrs: {
          columns: _vm.tableOptions.columns,
          options: _vm.tableOptions.options,
        },
        on: { loading: _vm.handleTableLoading, loaded: _vm.handleTableLoaded },
        scopedSlots: _vm._u([
          {
            key: "suppressed",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", { staticClass: "form-group-checkbox" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "pretty p-icon p-jelly p-smooth p-curve mr-0",
                    },
                    [
                      _c("input", {
                        staticClass: "checkbox select-recipient-event",
                        attrs: {
                          type: "checkbox",
                          "true-value": "true",
                          name: "select-recipient-" + row.id,
                        },
                        domProps: { checked: row.suppressed },
                        on: {
                          click: function ($event) {
                            return _vm.handleSelectRecipient(row)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "state p-danger" }, [
                        _c("i", { staticClass: "icon fa fa-times" }),
                        _vm._v(" "),
                        _c("label", {
                          attrs: { for: "select-recipient-" + row.id },
                        }),
                      ]),
                    ]
                  ),
                ]),
              ]
            },
          },
          {
            key: "appId",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("h5", { staticClass: "mb-0 font-sm text-gray" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(row.applicationInfo.applicationId) +
                      "\n      "
                  ),
                ]),
              ]
            },
          },
          {
            key: "name",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "a",
                  {
                    staticClass:
                      "regular my-auto text-primary text-capitalize bold clickable",
                    on: {
                      click: function ($event) {
                        return _vm.handleGoToClientApp(row)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(row.givenName) +
                        " " +
                        _vm._s(row.familyName) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "email",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("h5", { staticClass: "mb-0 font-sm text-gray" }, [
                  _vm._v("\n        " + _vm._s(row.email) + "\n      "),
                ]),
              ]
            },
          },
          {
            key: "mortgage",
            fn: function (ref) {
              var row = ref.row
              return [
                _vm.isRenewalAutomation
                  ? _c("h5", { staticClass: "mb-0 font-sm text-gray" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            row.isExistingMortgage
                              ? _vm.$t("global.doorr.existingMortgage")
                              : _vm.$t("global.doorr.requestedMortgage")
                          ) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "scheduled",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("h5", { staticClass: "mb-0 font-sm" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("formatDate")(row.scheduledDate)) +
                      "\n      "
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }